import { createSlice } from "@reduxjs/toolkit";
 
const initialState = {
    scorecards: []
  };
 
const scoreCardSlice = createSlice({
    name:"CUADRO_MANDO",
    initialState,
    reducers: { 
        setScoreCardSlice: (state, action) => {
            return {
                ...state,
                scorecards: action.payload,
            };
        },
        clearScoreCard: () =>  initialState
    }
})
export const { setScoreCardSlice, clearScoreCard } = scoreCardSlice.actions; 
export const selectScoreCard = state => state.CUADRO_MANDO;
export default scoreCardSlice.reducer;